import { Lightbulb } from "lucide-react";
import { DEFAULT_LOCALE, type SupportedLocale } from "@patient-watch/i18n";

function noDataCopy(locale: SupportedLocale) {
    if (locale === "de-DE") {
        return { title: "Noch keine Daten", body: "Fügen Sie Ihren ersten Eintrag hinzu, um den Verlauf zu sehen" };
    }
    if (locale === "fr-FR") {
        return {
            title: "Pas encore de données",
            body: "Ajoutez votre première saisie pour suivre votre progression",
        };
    }
    if (locale === "it-IT") {
        return {
            title: "Nessun dato ancora",
            body: "Aggiunga il primo inserimento per seguire i Suoi progressi",
        };
    }
    if (locale === "es-ES") {
        return {
            title: "Aún no hay datos",
            body: "Añada el primer registro para seguir su progreso",
        };
    }
    if (locale === "da-DK") {
        return {
            title: "Ingen data endnu",
            body: "Tilføj din første indtastning for at begynde at følge dine fremskridt",
        };
    }
    return { title: "No Data Yet", body: "Add your first entry to start tracking your progress" };
}

const NoDataPlaceholder = ({ locale = DEFAULT_LOCALE }: { locale?: SupportedLocale }) => {
    const copy = noDataCopy(locale);
    return (
        <div className="flex flex-col justify-center items-center p-8 text-muted-foreground text-center">
            <Lightbulb className="mb-2 w-8 h-8" />
            <h3 className="mb-1 font-semibold text-lg">{copy.title}</h3>
            <p className="text-sm">{copy.body}</p>
        </div>
    );
};

export default NoDataPlaceholder;
